import { Component, inject, Inject } from '@angular/core';
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BehaviorSubject, Subject, takeUntil, tap } from 'rxjs';
import { MediabankFile } from 'src/app/admin/mediabank/mediabank-models';
import { MediaService } from '../../modules/services/media.service';
import { CdnPipe } from 'src/app/bee-pipes/cdn/cdn.pipe';
import { AuthenticationService } from 'src/app/authorize/services/authentication.service';

@Component({
  selector: 'bee-show-mandatory-media',
  templateUrl: './show-mandatory-media.component.html',
  styleUrls: ['./show-mandatory-media.component.scss']
})
export class ShowMandatoryMediaComponent {
  public selectedFileUrl$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private mediaService: MediaService = inject(MediaService);
  public destroy$: Subject<void> = new Subject<void>();
  public cdnPipe = inject(CdnPipe);
  private authService = inject(AuthenticationService);

  public mediaToShow: MediabankFile;
  data: any = inject(MAT_DIALOG_DATA);

  constructor(public dialog: MatDialog) {
    if (this.data && this.data.files && this.data.files.length > 0) {
      this.mediaToShow = this.data.files[0];
      this.selectFile(this.mediaToShow);

    }
  }

  selectFile(file: MediabankFile): void {
    this.selectedFileUrl$.next(null);
    setTimeout(() => {
      this.selectedFileUrl$.next("https://docs.google.com/gview?embedded=true&url=" + this.cdnPipe.transform(file.fileUrl));
    }, 10);
    this.mediaService.LogEvent({ mediabankFileId: this.mediaToShow.id, eventType: 1 }).pipe(
      tap(() => {
        this.mediaService.LogEvent({ mediabankFileId: this.mediaToShow.id, eventType: 2 }).pipe(
          takeUntil(this.destroy$)
        ).subscribe((data: any) => {
        });
      }),
      takeUntil(this.destroy$)
    ).subscribe((data: any) => {
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
  closeDialog(): void {
    this.mediaService.LogEvent({ mediabankFileId: this.mediaToShow.id, eventType: 3 }).pipe(
      takeUntil(this.destroy$)
    ).subscribe((data: any) => {
      this.dialog.closeAll();
    });
  }

  logout(): void {
    this.authService.logout();
    window.location.reload();
  }

}
